import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Review = (props) => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3, // Adjust based on layout
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    return (
        <div className="reviewParent">
            <Slider {...settings}>
                {props.data.map((review, index) => (
                    <div className="reviewCardParent">
                        <div
                            className="reviewCard d-flex flex-column align-items-center"
                            key={index}
                        >
                            <img src="/assets/images/user-profile.webp" />
                            <p>{review.description}</p>

                            <div className="reviewer">
                                <hr />
                                <h4>{review.users_first_name + ' ' + review.users_last_name}</h4>
                                <p>{review.position}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    )
}

export default Review
